module.exports = __webpack_public_path__ + "img/npc_dota_hero_warp_beast.43330fac.png";